module.exports = __webpack_public_path__ + "static/Banner-b7d0202982b20503c609a45633d2a17a.png";